import { render, staticRenderFns } from "./WOSearch.vue?vue&type=template&id=5e5074bc&scoped=true&"
import script from "./WOSearch.vue?vue&type=script&lang=js&"
export * from "./WOSearch.vue?vue&type=script&lang=js&"
import style0 from "./WOSearch.vue?vue&type=style&index=0&id=5e5074bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5074bc",
  null
  
)

export default component.exports